<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { menuItems } from '@/constants/menu-items'

const router = useRouter()
const route = useRoute()
const activePath = computed(() => route.path)

const isActive = (menuLink: string) => {
  if (menuLink === '/') {
    return activePath.value === '/'
  }
  return activePath.value.startsWith(menuLink)
}
</script>

<template>
    <div class=" flex lg:hidden flex-col gap-4 mt-32 px-4">
        <!-- 👉 Sidebar menu -->
        <div class=" w-full flex flex-col bg-white rounded-xl gap-0.5 px-1.5 pb-4">
            <div v-for="(menu, index) in menuItems" :key="`menu-item-${index}`" class="d-flex items-center py-2 h-10">
                <router-link :to="menu.link"
                    class="flex items-center gap-2 px-1 h-10  cursor-pointer text-[#1b325a] hover:bg-[#f5f7fa] rounded-lg text-[13px] font-medium"
                    :class="{
                        'bg-[#eaeef5]': isActive(menu.link)
                    }">
                    <img :src="menu.icon_url" width="22" alt="menu-icon" />
                    {{ menu.title }}
                </router-link>
            </div>
        </div>
    </div>
</template>
